module.exports = __webpack_public_path__ + "static/media/vacker.b91a0f26.mp3";